export default {
    baseStyle: {
        productWapper: {
            width: '100%',
            borderTopWidth: {base: '1px', md: '0'},
            borderBottomWidth: '1px',
            borderStyle: 'solid',
            borderColor: 'gray.875',
            paddingTop: {base: '30px', md: '0'},
            paddingBottom: '20px',
            align: 'flex-start'
        },
        product: {
            width: '100%',
            alignItems: 'flex-start',
            gap: {base: '15px', md: 'none'},
            padding: '10px 0'
        },
        productDetailImg: {
            width: {base: '165px', md: '230px'},
            marginRight: 2
        },
        productDetail: {
            width: '100%',
            gap: '15px',
            marginTop: '-3px'
        },
        orderWrapper: {
            bg: {base: 'gray.120', md: 'gray.150'},
            padding: {base: '25px 5px 0px 5px', md: '50px 15px 40px 15px'},
            width: {base: '100%', lg: '375px'},
            gap: 0,
            position: 'sticky',
            top: {base: '0px', md: '150px'}
        },
        heading: {
            fontFamily: 'UniversLTStd, Arial, sans-serif',
            fontSize: {base: '18px', md: '25px'},
            textTransform: 'uppercase',
            fontWeight: {base: '400', md: '700'},
            paddingTop: {base: '4px', md: '0'},
            display: 'flex',
            gap: '15px',
            alignItems: 'center'
        },
        taxPriceNormal: {
            fontSize: 'md'
        },
        headingIcon: {
            display: {md: 'none'}
        },
        modLink: {
            color: 'black',
            fontSize: {base: '13px', md: '15px'},
            textDecoration: 'underline',
            fontWeight: '400',
            position: 'absolute',
            top: {base: '-10px', md: '10px'},
            right: {base: '0px', md: '10px'}
        },
        promoCode: {width: '100%'},
        taxPrice: {
            color: 'black',
            fontSize: 'md'
        },
        priceText: {
            justifyContent: 'space-between'
        },
        subTotal: {
            justify: 'space-between'
        },
        textBold: {
            fontWeight: 'bold',
            fontSize: 'md'
        },
        priceTextText: {
            fontSize: 'md',
            fontWeight: '700',
            color: 'red.650'
        },
        priceTextVAT: {
            fontSize: 'md'
        },
        darkText: {
            color: 'black',
            fontSize: 'md'
        },
        secText: {
            color: 'black',
            fontSize: 'md'
        },
        discountAmount: {
            fontWeight: '700',
            color: 'red.650',
            fontSize: 'md',
            marginLeft: '0.2rem'
        },
        pricingDetail: {
            spacing: 4,
            align: 'flex-start',
            paddingTop: {base: '0', md: '20px'}
        },
        price: {
            width: '100%'
        },
        shipping: {
            justifyContent: 'space-between'
        },
        shippingFlexBox: {
            alignItems: 'center'
        },
        shippingFlexBoxText: {
            lineHeight: '1.6',
            fontSize: 'md',
            width: '80%'
        },
        estimatedDelivery: {
            lineHeight: '1.6',
            fontSize: 'md',
            fontStyle: 'Italic',
            display: 'block',
            color: 'gray.675'
        },
        shippingFlexBoxSpan: {
            marginLeft: '16px'
        },
        total: {
            width: '100%'
        },
        pricingDetailTotalFlexBox: {
            width: '100%',
            justify: 'space-between'
        },
        pricingDetailTotalFlexBoxText: {
            fontWeight: 'bold',
            fontSize: 'md'
        },
        promotion: {
            width: '100%',
            display: 'flex'
        },
        promotionFlexBox: {
            alignItems: 'center'
        },
        promotionFlexBoxText: {
            flex: '1',
            fontSize: 'md',
            color: 'gray.900',
            display: 'flex'
        },
        redButton: {
            size: 'sm',
            colorScheme: 'red'
        },
        promoAmount: {
            fontWeight: '700',
            fontSize: 'md',
            marginLeft: '0.2rem'
        },
        appliedStyle: {
            fontSize: 'md',
            fontWeight: '700',
            color: 'green.450'
        },
        promoStack: {
            width: '100%',
            gap: '0'
        }
    }
}
